export interface SelectableOrigin {
  name: string;
  key: string;
}

// Create Account retains its built-in options. Quick Login only displays an
// origin selector when a valid list was explicitly configured.
export const FALLBACK_ORIGINS: SelectableOrigin[] = [
  { name: 'Starry Spins', key: 'starry-spins' },
  { name: 'Christmas', key: 'christmas' },
];

type OriginConfig =
  | { origins: SelectableOrigin[]; error: null }
  | { origins: null; error: string };

// Shared by the login UI and the Nitro startup check. Nuxt may have already
// parsed the JSON environment variable before exposing runtimeConfig.
export function parseOriginConfig(raw: unknown): OriginConfig {
  if (raw == null || (typeof raw === 'string' && !raw.trim())) {
    return { origins: null, error: 'is missing, null, or empty' };
  }

  let parsed: unknown = raw;
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return { origins: null, error: 'contains malformed JSON' };
    }
  }

  if (!Array.isArray(parsed) || parsed.length === 0) {
    return { origins: null, error: 'must be a nonempty JSON array of {name, key} objects' };
  }

  const origins: SelectableOrigin[] = [];
  const keys = new Set<string>();
  for (const entry of parsed) {
    if (
      !entry || typeof entry.name !== 'string' || !entry.name.trim() ||
      typeof entry.key !== 'string' || !entry.key.trim() || entry.key.trim().length > 255
    ) {
      return { origins: null, error: 'contains an invalid entry (name and key must be nonempty strings; key must be at most 255 characters)' };
    }
    const origin = { name: entry.name.trim(), key: entry.key.trim() };
    if (keys.has(origin.key)) {
      return { origins: null, error: 'contains duplicate origin keys' };
    }
    keys.add(origin.key);
    origins.push(origin);
  }

  return { origins, error: null };
}
